/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import { ConfigManager } from './ConfigManager';
import { printLog } from './utils';

const PUBLIC_ROUTE_PREFIXES = [
  '/credit/apply',
  '/credit/resume',
  '/credit/submitted',
  '/credit/email-verification',
];

const isPublicCreditRoute = (pathname: string) => {
  return PUBLIC_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
};

export const routeLoginPage = (authPath?: string) => {
  if (isPublicCreditRoute(window.location.pathname)) {
    return;
  }

  if (window.self !== window.top) {
    if (window.top) {
      ConfigManager.v4OrderDetailsHost.split(',').forEach((host) => {
        try {
          parent.postMessage(
            {
              message: 'navigateToLoginPage',
            },
            {
              targetOrigin: host,
            },
          );
        } catch (e) {
          printLog(
            'There was an error posting message to parent -- this is expected',
            e,
          );
        }
      });
    }
  } else if (
    ConfigManager.showLayout &&
    window.location.pathname !== '/account/login'
  ) {
    // @ts-expect-error This works just fine.
    window.location = `/account/login${
      !!authPath ? `?auth_url=${authPath}` : ''
    }`;
  }
};
